var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('async-sidebar',{attrs:{"async-component":_vm.Microcart,"is-open":_vm.isMicrocartOpen},on:{"close":function($event){return _vm.$store.commit('ui/setMicrocart', false)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }